import styled from 'styled-components';

export const MobilePositionCreateStyled = styled.div`
    flex: 1;
    padding: 16px;

    .btn {
        width: 100%;
    }
`;

export const MobilePositionCreateAmountPresetsStyled = styled.div.attrs(({ big }) => ({ className: big ? 'big' : '' }))`
    display: flex;
    flex-direction: row;
    gap: 8px;
    user-select: none;
    overflow: auto;

    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    &::-webkit-scrollbar {
        display: none;
    }
    
    svg {
        fill: #FFFFFF;
    }

    > * {
        text-align: center;
        flex: 1;
        background: rgba(129, 146, 228, 0.1);
        color: rgba(255, 255, 255, 0.6);
        border-radius: 12px;
        padding: 12px;
        cursor: default;
    }

    &.big {
        font-size: 18px;
    }
`;

export const MobilePositionCreatePresetsStyled = styled.div`
    width: 100%;
    margin-top: 12px;
    margin-bottom: 32px;
`;

export const MobilePositionCreateChartStyled = styled.div`
    margin-left: -16px;
    margin-right: -16px;
`;

export const MobilePositionCreateInsufficientFundsStyled = styled.div`
    padding: 12px 0 8px;
    display: flex;
    flex-direction: column;
    position: relative;
    
    h3 {
        font-weight: 600;
        font-size: 16px;
    }
    
    p {
        margin-top: 12px;
        margin-bottom: 0;
    }
    
    button {
        margin-top: 24px;
    }
`;

export const MobilePositionCreateInsufficientFundsCloseStyled = styled.div`
    position: absolute;
    padding: 12px;
    top: -8px;
    right: -8px;
    
    svg {
        fill: var(--color-white-60);
    }
`;
